import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { ProgressSpinner } from "primereact/progressspinner";
import { useTranslation } from 'react-i18next';
export default function Activity(props) {
  const { data, fetchInProgress } = props;
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const { t } = useTranslation();
  const ACTIVITY=t("ACTIVITY")
  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData({
      ...data,
      datasets: data.datasets.map((dataset) => ({
        ...dataset,
        borderColor: documentStyle.getPropertyValue("--blue-500"),
      })),
    });
    setChartOptions(options);
  }, [data]);

  return (
    <main id="events" className="main-page">
      <section className="page-section q-pa-md">
        <div className="container-fluid">
          <div className="grid">
            <div className="col comp-grid">
              <h5>{ACTIVITY}</h5>
            </div>
          </div>
          <div
            style={{
              minHeight: "350px",
              display: fetchInProgress ? "flex" : "block",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {fetchInProgress ? (
              <ProgressSpinner />
            ) : (
              <Chart type="line" data={chartData} options={chartOptions} />
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
